import { LoginOptions } from "@remo-co/types";

export const nonSsoLoginOptions: string[] = [
  LoginOptions.EMAIL_LINK,
  LoginOptions.EMAIL_WITH_PASSWORD,
  LoginOptions.ANONYMOUS,
];
